import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  fetchToursDetail,
  ApproveRejectTour,
  TourGalleryModeration,
} from "../../redux/moderation/tours/actions";
import CrossIcon from "../../assets/images/close_icon.svg";
import TickIcon from "../../assets/images/tick_icon.svg";
import history from "../../history";
import InputText from "../InputText";
import config from "../../utils/config";
import { fetchPartnersDetails } from "../../redux/partners/actions";
import moment from "moment";
import get from "lodash/get";


export default function TourPreviewPage(props) {
  
  const _ = { get };
  const { elements } = useSelector((state) => state.Elements);
  const {  userProfile } = useSelector((state) => state.Auth);
  return (
    <React.Fragment>
      {console.log("ptops",props.tourDetailsData)}
      <div className="hideSearch mt-4">
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={`${props &&
                  props.tourDetailsData &&
                  props.tourDetailsData.name} by ${userProfile.fName} ${userProfile.lName}`}
                iconClass={"hideexcel"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            <CardBody>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span > {_.get(
                        elements,
                        "euToursElement.toursPersonalPreviewInfo.partnerDeatilHeadingElement",
                        "Partner Detail"
                      )}</span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                   name={_.get(
                    elements,
                    "euToursElement.toursPersonalPreviewInfo.nameLabel",
                    "Name"
                  )}
                    titleName={`${userProfile.fName} ${userProfile.lName}`}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                      name={_.get(
                        elements,
                        "euToursElement.toursPersonalPreviewInfo.emailLabel",
                        "Email"
                      )}
                    titleName={`${userProfile.contact.email}`}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span> {_.get(
                        elements,
                        "euToursElement.toursPersonalPreviewInfo.tourDetailHeadingElement",
                        "Tour Detail"
                      )}</span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.nameLabel",
                      "Name"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.name
                        ? props.tourDetailsData.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                     name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.startLocationLabel",
                      "Start Location"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.startPoint
                        ? props.tourDetailsData.startPoint
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.startLocationLatitudeLabel",
                      "Start Location Latitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.startPointSourceLatitude
                        ? props.tourDetailsData.startPointSourceLatitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.startLocationLongitudeLabel",
                      "Start Location Longitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.startPointSourceLongitude
                        ? props.tourDetailsData.startPointSourceLongitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.endLocationLabel",
                      "End Location"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.endPoint
                        ? props.tourDetailsData.endPoint
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.endLocationLatitude",
                      "End Location Latitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.endPointSourceLatitude
                        ? props.tourDetailsData.endPointSourceLatitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                     name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.endLocationLongitude",
                      "End Location Longitude"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.endPointSourceLongitude
                        ? props.tourDetailsData.endPointSourceLongitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.startDateLabel",
                      "Start Date"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.startDate
                        ? moment(props.tourDetailsData.startDate).format(
                            "DD/MM/YYYY"
                          )
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                     name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.endDateLabel",
                      "End Date"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.endDate
                        ? moment(props.tourDetailsData.endDate).format(
                            "DD/MM/YYYY"
                          )
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.regionLabel",
                      "Region"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.region
                        ? props.tourDetailsData.region
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.countryLabel",
                      "Country"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.country
                        ? props.tourDetailsData.country
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.distanceCoveredLabel",
                      "Estimated Distance Covered (KM)"
                    )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.distanceCovered
                        ? props.tourDetailsData.distanceCovered
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={12} className="mb-4 mt-3">
                  <DesignCard
                      name={_.get(
                        elements,
                        "euToursElement.toursPersonalPreviewInfo.descriptionLabel",
                        "Description"
                      )}
                    titleName={
                      props &&
                      props.tourDetailsData &&
                      props.tourDetailsData.description
                        ? props.tourDetailsData.description
                        : "N/A"
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span> {_.get(
                        elements,
                        "euToursElement.toursPersonalPreviewInfo.mediaTitle",
                        "Media"
                      )}</span>
                  </h2>
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <div className="image_heading">
                  {_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.thumbnailImageLabel",
                      "Tour Landing Page - Thumbnail - Common (160 x 190 px)"
                    )}
                  </div>
                  {props &&
                  props.tourDetailsData &&
                  props.tourDetailsData.thumbnailImage ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props &&
                        props.tourDetailsData &&
                        props.tourDetailsData.thumbnailImage}
                      `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <div className="image_heading">
                  {_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.thumbnailImageDetailPageLabel",
                      "Partner Detail Page - Tour Listing Thumbnail - Common (360 x 310 px)"
                    )}
                  </div>
                  {props &&
                  props.tourDetailsData &&
                  props.tourDetailsData.thumbnailPartnerImage ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props &&
                        props.tourDetailsData &&
                        props.tourDetailsData.thumbnailPartnerImage}
                      `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={12} className="mt-4 mb-2">
                  <div className="image_heading">
                  {_.get(
                      elements,
                      "euToursElement.toursPersonalPreviewInfo.galleryImageLabel",
                      "Gallery Images Common"
                    )}
                  </div>
                </Col>
                {props &&
                props.tourDetailsData &&
                props.tourDetailsData.images && props.tourDetailsData.images.length > 0
                  ? props.tourDetailsData.images.map((item) => (
                      <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                        <img
                          className="image_tour2"
                          src={`${config.imageBaseUrl}/${item}`}
                          alt="img"
                        />
                      </Col>
                    ))
                  : "N/A"}
              </Row>

              <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-5">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "euToursElement.toursPersonalPreviewInfo.backLabel",
                    "Back"
                  )}
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() => props.handleToggleModel()}
                />
              </div>
            </CardBody>
          </Card>
        </Form>
      </div>
    </React.Fragment>
  );
}


